/*Get CENTRES */
export const GET_CENTRES = "GET_CENTRES"
export const GET_CENTRES_SUCCESS = "GET_CENTRES_SUCCESS"
export const GET_CENTRES_FAIL = "GET_CENTRES_FAIL"

/*Get ETHNICITIES */
export const GET_ETHNICITIES = "GET_ETHNICITIES"
export const GET_ETHNICITIES_SUCCESS = "GET_ETHNICITIES_SUCCESS"
export const GET_ETHNICITIES_FAIL = "GET_ETHNICITIES_FAIL"

/*Get PHONECONTRACTS */
export const GET_PHONECONTRACTS = "GET_PHONECONTRACTS"
export const GET_PHONECONTRACTS_SUCCESS = "GET_PHONECONTRACTS_SUCCESS"
export const GET_PHONECONTRACTS_FAIL = "GET_PHONECONTRACTS_FAIL"

/*Get NDBNETWORKTYPES */
export const GET_NDBNETWORKTYPES = "GET_NDBNETWORKTYPES"
export const GET_NDBNETWORKTYPES_SUCCESS = "GET_NDBNETWORKTYPES_SUCCESS"
export const GET_NDBNETWORKTYPES_FAIL = "GET_NDBNETWORKTYPES_FAIL"

/*Get HEALTHDAYS */
export const GET_HEALTHDAYS = "GET_HEALTHDAYS"
export const GET_HEALTHDAYS_SUCCESS = "GET_HEALTHDAYS_SUCCESS"
export const GET_HEALTHDAYS_FAIL = "GET_HEALTHDAYS_FAIL"

/* Add HEALTHDAY */
export const ADD_HEALTHDAY = "ADD_HEALTHDAY"
export const ADD_HEALTHDAY_SUCCESS = "ADD_HEALTHDAY_SUCCESS"
export const ADD_HEALTHDAY_FAIL = "ADD_HEALTHDAY_FAIL"

/* Update HEALTHDAY */
export const UPDATE_HEALTHDAY = "UPDATE_HEALTHDAY"
export const UPDATE_HEALTHDAY_SUCCESS = "UPDATE_HEALTHDAY_SUCCESS"
export const UPDATE_HEALTHDAY_FAIL = "UPDATE_HEALTHDAY_FAIL"

/*Get HEALTHDAY DETAIL */
export const GET_HEALTHDAY_DETAIL = "GET_HEALTHDAY_DETAIL"
export const GET_HEALTHDAY_DETAIL_SUCCESS = "GET_HEALTHDAY_DETAIL_SUCCESS"
export const GET_HEALTHDAY_DETAIL_FAIL = "GET_HEALTHDAY_DETAIL_FAIL"

/*Add FILE UPLOAD */
export const ADD_HEALTHDAY_FILEUPLOAD = "ADD_HEALTHDAY_FILEUPLOAD"
export const ADD_HEALTHDAY_FILEUPLOAD_SUCCESS =
  "ADD_HEALTHDAY_FILEUPLOAD_SUCCESS"
export const ADD_HEALTHDAY_FILEUPLOAD_FAIL = "ADD_HEALTHDAY_FILEUPLOAD_FAIL"

// actionTypes.js
export const ADD_HEALTHDAY_DATAUPLOAD = "ADD_HEALTHDAY_DATAUPLOAD"
export const ADD_HEALTHDAY_DATAUPLOAD_SUCCESS =
  "ADD_HEALTHDAY_DATAUPLOAD_SUCCESS"
export const ADD_HEALTHDAY_DATAUPLOAD_FAIL = "ADD_HEALTHDAY_DATAUPLOAD_FAIL"

/**
 * CENTRE TYPES
 */
export const GET_CENTRE_TYPES = "GET_CENTRE_TYPES"
export const GET_CENTRE_TYPES_SUCCESS = "GET_CENTRE_TYPES_SUCCESS"
export const GET_CENTRE_TYPES_FAIL = "GET_CENTRE_TYPES_FAIL"

/**
 * Add CENTRE
 */
export const ADD_CENTRE = "ADD_CENTRE"
export const ADD_CENTRE_SUCCESS = "ADD_CENTRE_SUCCESS"
export const ADD_CENTRE_FAIL = "ADD_CENTRE_FAIL"

/**
 * Update CENTRE
 *
 */
export const UPDATE_CENTRE = "UPDATE_CENTRE"
export const UPDATE_CENTRE_SUCCESS = "UPDATE_CENTRE_SUCCESS"
export const UPDATE_CENTRE_FAIL = "UPDATE_CENTRE_FAIL"

/*Get CENTRE DETAIL */
export const GET_CENTRE_DETAIL = "GET_CENTRE_DETAIL"
export const GET_CENTRE_DETAIL_SUCCESS = "GET_CENTRE_DETAIL_SUCCESS"
export const GET_CENTRE_DETAIL_FAIL = "GET_CENTRE_DETAIL_FAIL"

/*Clear State*/
export const CLEAR_HEALTHDAY_STATE = "CLEAR_HEALTHDAY_STATE"
